import { core, toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  result: core.BusinessMarketing[] | null;
  isInitialized: boolean;
  isInitializedOnBrowser: boolean;
  requestInProgress: boolean;
}

const initialState: State = {
  result: null,
  isInitialized: false,
  isInitializedOnBrowser: false,
  requestInProgress: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.DISCOVER_FETCH_ALL_DONE:
      return {
        ...state,
        result: toJSONArray<core.BusinessMarketing>(payload),
        requestInProgress: false,
      };
    case AppConstants.DISCOVER_SEARCH_STARTING:
    case AppConstants.DISCOVER_FETCH_ALL_STARTING:
      return {
        ...state,
        requestInProgress: state.isInitializedOnBrowser,
      };
    case AppConstants.DISCOVER_SEARCH_FAILED:
    case AppConstants.DISCOVER_FETCH_ALL_FAILED:
      return {
        ...state,
        requestInProgress: false,
      };
    case AppConstants.DISCOVER_SEARCH_DONE:
      return {
        ...state,
        result: toJSONArray(payload.business),
        isInitialized: true,
        isInitializedOnBrowser: BROWSER,
        requestInProgress: false,
      };
    default:
      return state;
  }
}
